export default __webpack_public_path__ + "static/media/cryptocoins.31c0d87f.woff2";